import { Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import {
  Code2,
  Globe,
  Link2,
  RefreshCcw,
  Search,
  GraduationCap,
  Smartphone,
  TabletSmartphone,
  Navigation,
  ShoppingBag,
  Wifi,
  Palette,
  BellRing,
  ShieldCheck,
  ArrowRight,
  CheckCircle2,
} from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ServicesPage() {
  const services = [
    {
      id: "odoo-sur-mesure",
      icon: Code2,
      title: "Modules Odoo sur mesure",
      description:
        "Votre métier est unique — votre Odoo doit l'être aussi. Nous développons des modules Odoo entièrement personnalisés : modèles de données, vues, rapports QWeb, automatisations, assistant IA intégré.",
      features: [
        "Analyse fonctionnelle complète",
        "Modèles Python & ORM Odoo",
        "Vues OWL / QWeb",
        "Rapports & tableaux de bord",
        "Tests unitaires et d'intégration",
        "Documentation technique incluse",
      ],
      image: "https://images.unsplash.com/photo-1554306274-f23873d9a26c?w=800&q=80",
    },
    {
      id: "sites-portails",
      icon: Globe,
      title: "Sites web & portails Odoo",
      description:
        "Sites vitrines, boutiques e-commerce et portails client construits sur Odoo Website. Design sur mesure, SEO, catalogue connecté au stock, paiement en ligne.",
      features: [
        "Odoo Website & eCommerce",
        "Thèmes 100 % sur mesure",
        "Catalogue connecté au stock Odoo",
        "Paiement en ligne (Stripe, Mollie)",
        "SEO technique et contenus",
        "Hébergement Odoo.sh ou VPS",
      ],
      image: "https://images.unsplash.com/photo-1559028012-481c04fa702d?w=800&q=80",
    },
    {
      id: "applications-mobiles",
      icon: Smartphone,
      title: "Applications mobiles iOS & Android",
      description:
        "Applications client, e-commerce ou métier connectées à Odoo. Nous concevons des expériences rapides, sécurisées et pensées pour le terrain, du prototype à la publication sur les stores.",
      features: [
        "Applications iOS, Android & PWA",
        "React Native, Flutter ou web mobile",
        "Connexion sécurisée à Odoo & vos APIs",
        "Mode hors ligne et synchronisation",
        "Notifications push & géolocalisation",
        "Publication et maintenance des stores",
      ],
      image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&q=80",
    },
    {
      id: "integrations-api",
      icon: Link2,
      title: "Intégrations API tierces",
      description:
        "Connecter Odoo à votre écosystème existant : marketplace, ERP, logistique, comptabilité, CRM externe, outils SaaS. Développement de connecteurs robustes et testés.",
      features: [
        "API REST / JSON-RPC",
        "Webhooks entrants et sortants",
        "EDI & échanges fichiers",
        "Connecteurs marketplace",
        "Synchronisation temps réel",
        "Monitoring et alertes",
      ],
      image: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&q=80",
    },
    {
      id: "migration-odoo",
      icon: RefreshCcw,
      title: "Migration Odoo",
      description:
        "Passez à Odoo 18 ou 19 sans risque. Nous auditons vos modules tiers, migrons vos données, adaptons votre code et assurons un go-live serein.",
      features: [
        "Audit de la version source",
        "Migration données (Python scripts)",
        "Portage modules sur mesure",
        "Tests de non-régression",
        "Environnement de pré-prod",
        "Accompagnement go-live",
      ],
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    },
    {
      id: "audit-odoo",
      icon: Search,
      title: "Audit & Conseil Odoo",
      description:
        "Vous avez un Odoo existant qui pose des problèmes ? Nous l'analysons en profondeur et livrons un rapport d'audit avec des recommandations priorisées.",
      features: [
        "Audit performance (profiling)",
        "Revue du code des modules tiers",
        "Analyse de sécurité",
        "Bonnes pratiques Odoo",
        "Recommandations priorisées",
        "Plan d'action chiffré",
      ],
      image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=800&q=80",
    },
    {
      id: "formation-maintenance",
      icon: GraduationCap,
      title: "Formation & Maintenance",
      description:
        "Rendre vos équipes autonomes et garantir la pérennité de votre Odoo. Formations sur mesure, contrats de maintenance mensuelle, support réactif.",
      features: [
        "Formations administrateurs",
        "Formations utilisateurs métier",
        "Supports écrits et vidéos",
        "Contrat maintenance mensuel",
        "Correctifs et mises à jour",
        "Support par tickets et SLA",
      ],
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80",
    },
  ];

  const mobileSolutions = [
    {
      icon: TabletSmartphone,
      title: "Apps clients & commerciales",
      description:
        "Espace client, réservation, fidélité, suivi de commande, devis et services en libre-service dans une expérience mobile fluide.",
    },
    {
      icon: Navigation,
      title: "Apps métier & terrain",
      description:
        "Interventions, états des lieux, tournées, photos, scan de codes-barres, signature et saisie hors connexion pour vos équipes mobiles.",
    },
    {
      icon: ShoppingBag,
      title: "M-commerce connecté",
      description:
        "Catalogue, stock, panier, paiement et historique synchronisés avec Odoo pour vendre et servir vos clients partout.",
    },
    {
      icon: Wifi,
      title: "IoT & équipements connectés",
      description:
        "Remontée de capteurs, alertes, télémétrie et maintenance préventive reliées à vos véhicules, machines ou sites.",
    },
    {
      icon: Palette,
      title: "UX/UI & prototypage",
      description:
        "Parcours utilisateurs, maquettes interactives et design system avant développement pour sécuriser les choix et accélérer la recette.",
    },
    {
      icon: BellRing,
      title: "Exploitation & évolutions",
      description:
        "Suivi des performances, notifications, analytics, mises à jour iOS/Android, maintenance corrective et évolutive.",
    },
  ];

  const mobileStack = [
    "React Native",
    "Flutter",
    "PWA",
    "iOS",
    "Android",
    "Odoo API",
    "REST & Webhooks",
    "Offline-first",
    "Notifications push",
  ];

  const process = [
    {
      step: "01",
      title: "Découverte",
      description:
        "Échange sur votre contexte Odoo, votre version, vos modules existants et vos objectifs métier.",
    },
    {
      step: "02",
      title: "Fiche de cadrage",
      description:
        "Rédaction des spécifications fonctionnelles, schéma de données, estimation en jours et planning.",
    },
    {
      step: "03",
      title: "Développement",
      description:
        "Sprints courts, démos régulières, code hébergé sur Git, revue de code systématique.",
    },
    {
      step: "04",
      title: "Recette",
      description:
        "Tests en environnement de pré-prod avec vos utilisateurs. Corrections et ajustements inclus.",
    },
    {
      step: "05",
      title: "Mise en production",
      description:
        "Déploiement maîtrisé, migration des données, vérification post-déploiement.",
    },
    {
      step: "06",
      title: "Suivi & évolutions",
      description:
        "Maintenance préventive, montées de version, nouvelles fonctionnalités et support continu.",
    },
  ];

  return (
    <div className="min-h-screen" data-testid="services-page">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-24 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-slate-50 to-white" />

        <div className="nova-container relative z-10">
          <div className="max-w-3xl">
            <h1
              className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6"
              data-testid="services-title"
            >
              Tout ce qu'il faut pour réussir votre projet{" "}
              <span className="nova-gradient-text">Odoo & mobile</span>
            </h1>
            <p className="text-lg text-slate-600 mb-8">
              Du module Odoo à l'application iOS ou Android, de l'intégration
              API à la maintenance — un seul interlocuteur pour votre écosystème métier.
            </p>
            <Link to="/onboarding">
              <Button className="nova-btn-primary">
                Décrire mon projet
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="nova-section bg-white">
        <div className="nova-container">
          <div className="space-y-24">
            {services.map((service, index) => (
              <div
                key={index}
                id={service.id}
                className="grid lg:grid-cols-2 gap-12 items-center scroll-mt-28"
                data-testid={`service-detail-${index}`}
              >
                <div className={index % 2 === 1 ? "lg:order-2" : ""}>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 bg-indigo-100 rounded-xl flex items-center justify-center">
                      <service.icon className="w-6 h-6 text-indigo-600" />
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold text-slate-900">
                      {service.title}
                    </h2>
                  </div>
                  <p className="text-slate-600 mb-6">{service.description}</p>
                  <div className="grid sm:grid-cols-2 gap-3">
                    {service.features.map((feature, fIndex) => (
                      <div key={fIndex} className="flex items-center gap-2">
                        <CheckCircle2 className="w-4 h-4 text-indigo-600 shrink-0" />
                        <span className="text-sm text-slate-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className={index % 2 === 1 ? "lg:order-1" : ""}>
                  <div className="relative">
                    <div className="absolute -inset-4 bg-indigo-100 rounded-3xl -rotate-2" />
                    <img
                      src={service.image}
                      alt={service.title}
                      className="relative rounded-2xl shadow-lg w-full aspect-[4/3] object-cover"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mobile Solutions */}
      <section id="solutions-mobiles" className="nova-section bg-slate-950 text-white scroll-mt-24" data-testid="mobile-solutions-section">
        <div className="nova-container">
          <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-14 items-start">
            <div className="lg:sticky lg:top-28">
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-500/15 text-indigo-300 rounded-full text-sm font-medium mb-6">
                <Smartphone className="w-4 h-4" />
                Nouvelle expertise NovaForge
              </span>
              <h2 className="text-3xl md:text-4xl font-bold mb-5">
                Vos processus métier, directement dans la poche
              </h2>
              <p className="text-slate-300 leading-relaxed mb-8">
                Nous transformons vos workflows Odoo en applications mobiles simples à utiliser.
                Vos équipes gagnent du temps sur le terrain et vos clients accèdent à vos services
                sans attendre d'être devant un ordinateur.
              </p>
              <div className="flex flex-wrap gap-2">
                {mobileStack.map((technology) => (
                  <span
                    key={technology}
                    className="px-3 py-1.5 rounded-full border border-white/10 bg-white/5 text-xs text-slate-300"
                  >
                    {technology}
                  </span>
                ))}
              </div>
              <div className="mt-9">
                <Link to="/onboarding">
                  <Button className="bg-indigo-500 hover:bg-indigo-400 text-white rounded-full px-7 py-3 h-auto">
                    Étudier mon application
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </Link>
              </div>
            </div>

            <div className="grid sm:grid-cols-2 gap-5">
              {mobileSolutions.map((solution, index) => (
                <article
                  key={solution.title}
                  className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 hover:bg-white/[0.07] hover:border-indigo-400/30 transition-all"
                  data-testid={`mobile-solution-${index}`}
                >
                  <div className="w-11 h-11 rounded-xl bg-indigo-500/15 flex items-center justify-center mb-5">
                    <solution.icon className="w-5 h-5 text-indigo-300" />
                  </div>
                  <h3 className="text-lg font-bold mb-2">{solution.title}</h3>
                  <p className="text-sm leading-relaxed text-slate-400">{solution.description}</p>
                </article>
              ))}
            </div>
          </div>

          <div className="mt-14 grid sm:grid-cols-3 gap-4">
            {[
              [ShieldCheck, "Sécurité dès la conception", "Authentification, rôles, chiffrement et protection des données."],
              [RefreshCcw, "Une seule source de vérité", "Données mobiles et Odoo synchronisées, sans double saisie."],
              [GraduationCap, "Adoption accompagnée", "Recette, publication, formation et support de vos équipes."],
            ].map(([Icon, title, description]) => (
              <div key={title} className="flex gap-4 rounded-xl border border-white/10 p-5">
                <Icon className="w-5 h-5 text-indigo-300 shrink-0 mt-0.5" />
                <div>
                  <h3 className="font-semibold mb-1">{title}</h3>
                  <p className="text-xs leading-relaxed text-slate-400">{description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="nova-section bg-slate-50">
        <div className="nova-container">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Notre méthode</h2>
            <p className="text-slate-600 max-w-2xl mx-auto">
              Six étapes pour livrer chaque projet Odoo, web ou mobile avec rigueur,
              de la découverte initiale au support longue durée.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {process.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 border border-slate-100 hover:border-indigo-100 hover:shadow-lg transition-all"
                data-testid={`process-step-${index}`}
              >
                <span className="text-4xl font-bold text-indigo-100 mb-4 block">{item.step}</span>
                <h3 className="text-xl font-bold text-slate-900 mb-2">{item.title}</h3>
                <p className="text-slate-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="nova-section bg-indigo-600">
        <div className="nova-container text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Prêt à démarrer votre projet Odoo ou mobile ?
          </h2>
          <p className="text-indigo-100 mb-10 max-w-2xl mx-auto">
            Décrivez votre projet en 5 minutes. On vous recontacte
            sous 24h avec une première analyse et une estimation.
          </p>
          <Link to="/onboarding">
            <Button className="bg-white text-indigo-600 hover:bg-indigo-50 rounded-full px-10 py-4 h-auto text-base font-semibold">
              Commencer maintenant
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
